import { createAsyncThunk } from "@reduxjs/toolkit";

import * as api from "shared/api/methods";

import * as types from "./types";

export const getDashboardData = createAsyncThunk<any, void>(
  types.GET_DASHBOARD_DATA,
  async () => {
    const data = await api.getCurrentOrder();

    return data;
  }
);

export const refreshDashboardData = createAsyncThunk<any, void>(
  types.REFRESH_DASHBOARD_DATA,
  async () => {
    const data = await api.getCurrentOrder();
    return data;
  }
);
